<template>
  <div id="mask" v-show="true">
    <div class="voucher-count">
      <el-dialog 
        class="self-demo-dialog" 
        center 
        :visible.sync="voucherShow" 
        @close="closeVoucher" 
        append-to-body
      >
        <div class="voucher-title">《群侠传》充值</div>
        <el-form 
          :model="ruleForm" 
          :rules="rules" 
          name="ruleForm" 
          ref="ruleForm" 
          label-width="100px" 
          class="demo-ruleForm"
        >
          <el-form-item label="所在大区" prop="serverId">
            <el-select 
              v-model="ruleForm.serverId" 
              placeholder="请选择所在大区" 
              @change="handleServerChange"
            >
              <el-option
                style="font-size: 16px;"
                v-for="item in serverList"
                :key="item.serverId"
                :label="item.serverName"
                :value="item.serverId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="安全手机" prop="phone">
            <el-input 
              v-model="ruleForm.phone"   
              autocomplete="off" 
              placeholder="请输入安全手机号码"
            ></el-input>
          </el-form-item>

          <el-form-item label="角色名称" prop="roleName">
            <el-select 
              v-model="ruleForm.roleName" 
              placeholder="请选择角色名称"  
              @click.native="getQueryRoles"
            >
              <el-option
                style="font-size: 16px;"
                v-for="item in rolesList"
                :key="item.roleName"
                :label="item.roleName"
                :value="item.roleName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="充值金额" prop="rechargeId">
            <el-select
              v-model="ruleForm.rechargeId"
              :popper-append-to-body="false"
              placeholder="请选择充值档位"    
              @focus="handleRechargeClick"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.desc"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <!-- 立即充值图片 -->
        <div class="topup" @click="topup()"></div>

        <div class="msg">
          <button 
            :class="{ 'is-selected': isSelected }" 
            @click="toggleSelection"
          >
            {{ isSelected ? '' : '' }}
          </button>
          我同意
          <a @click="footerSkip(footer.userAgreement)">{{
            footer.userAgreement.title
          }}</a>
          {{ " | " }}
          <a @click="footerSkip(footer.privacyPolicy)">{{
            footer.privacyPolicy.title
          }}</a>
        </div>

        <div style="display: flex; align-items: center" class="message-content">
          温馨提示:充值比例为1元=10元宝 支持微信支付和支付宝支付
        </div>
      </el-dialog>

      <!-- 支付选择弹框 -->
      <div id="voucherPay">
        <el-dialog  
          class="voucher-count" 
          center 
          width="500px"  
          :visible.sync="voucherPayShow"  
          append-to-body
        >
          <div class="voucherPay">
            <!-- 支付方式选择 -->
            <div class="pay-type-selector" style="margin-bottom: 20px; text-align: center;">
              <el-radio-group v-model="selectedPayType" @change="handlePayTypeChange">
                <el-radio label="wechat" style="margin-right: 20px;">
                  <img src="../../../assets/image/pc/recharge/wxpay-01.png" alt="微信支付" style="width: 20px; height: 20px; margin-right: 5px;">
                  微信支付
                </el-radio>
                <el-radio label="alipay">
                  <img src="../../../assets/image/pc/recharge/zfbpay-01.png" alt="支付宝支付" style="width: 20px; height: 20px; margin-right: 5px;">
                  支付宝支付
                </el-radio>
              </el-radio-group>
            </div>
            
            <!-- 未选择支付方式时提示 -->
            <div v-if="!hasSelectedPayType" class="self-qr-desc" style="color: #ff4d4f;">
              请先选择支付方式
            </div>
            
            <!-- 选择支付方式后显示二维码 -->
            <div v-else>
              <div v-if="!qrCodeImg" class="loading-tip">正在生成支付二维码...</div>
              <!-- <p class="self-qr-desc">请扫以下二维码进行支付</p> -->
              <img v-else :src="qrCodeImg" style="height: 250px;width:250px;padding-left: 15%;"/>
              <div style="color: red; text-align: center; margin: 10px 0;">
                {{ payErrorMsg }}
              </div>
              <div class="self-qr-footer">
                <!-- <img 
                  :src="selectedPayType === 'wechat' ? '../../../assets/image/pc/recharge/anpc.png' : '../../../assets/image/pc/recharge/anpc.png'" 
                  alt 
                  style="width: 20px; height: 20px;"
                />  -->
                <p>{{ selectedPayType === 'wechat' ? '微信扫码' : '支付宝扫码' }}</p>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import utils from "../../../utils";
import { mapMutations } from "vuex";
import recharApi from '../../../api/rechargeApi'

export default {
  data() {
    // 手机号校验
    let checkPhone = (rule, value, callback) => {
      var reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("安全手机号码格式不正确"));
      }
    }

    return {
      isSelected: false, //选中事件
      voucherShow: false,
      productList: [],
      serverList: [],
      rolesList: [],
      voucherPayShow: false,
      buttonCheck: '',
      codeUrl: '',
      qrCodeImg: '',
      payAmount: '', // 支付的金额暂时没有使用
      selectedPayType: '', // 【修改1】初始化为空，不默认选择任何支付方式
      payErrorMsg: '', // 支付错误提示
      ruleForm: {
        appSource: "official",
        channelId: "official",
        deviceId: "4",
        payId: "", // 【修改2】初始化为空，不默认设置支付方式ID
        playerId: "0",
        rechargeId: '',
        roleId: "0",
        serverId: '',
        p700: { phone: '', roleName: '',  payWay:'WEIXIN', payType:'SCANPAY_WEIXIN'},
        p200: { phone: '', roleName: '' },
        phone: '',
        roleName: '',
  
        
      },
      rules: {
        roleName: [
          { required: true, message: '请选择角色名称', trigger: 'change' }
        ],
        serverId: [
          { required: true, message: '请选择所在大区', trigger: 'change' }
        ],
        rechargeId: [
          { required: true, message: '请选择充值金额', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入安全手机号码', trigger: 'blur' },
          { validator: this.noSpaces, trigger: 'blur' },
          { validator: checkPhone, trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    footer() {
      return this.$config.footer;
    },
    // 【新增计算属性】判断是否选择了支付方式
    hasSelectedPayType() {
      return !!this.selectedPayType;
    }
  },

  mounted() {
    this.getServerUrls(); // 获取所在大区
  },
 
  methods: {
    noSpaces(rule, value, callback) {
      if (value.indexOf(' ') >= 0) {
        callback(new Error('输入值不能包含空格'));
      } else {
        callback();
      }
    },

    //关闭弹框
    closeVoucher() {
      this.$emit("VoucherClose", false);
    },

    toggleSelection() {
      this.isSelected = !this.isSelected;
    },

    async footerSkip(item) {
      let { id, title, type } = item;
      this.$router.push({ path: "/detail", query: { id, title, type } });
    },

    async handleServerChange(serverId) {
      if (serverId) {
        this.ruleForm.rechargeId = '';
        this.$refs.ruleForm.clearValidate('rechargeId'); 
        this.productList = [];
      } else {
        this.productList = [];
        this.ruleForm.rechargeId = '';
      }
    },

    async handleRechargeClick() { 
      if (this.ruleForm.serverId) {
        await this.getProductUrls(this.ruleForm.serverId);
        this.ruleForm.rechargeId = '';
      } else {
        this.productList = [];
      }
    },

    async getProductUrls(serverId) {
      let params = { serverId: serverId }
      let ulrs = await recharApi.getProductUrls(params);
      this.productList = ulrs.data;
    },

    async getServerUrls() {
      let ulrs = await recharApi.getServerUrls();
      this.serverList = ulrs.data;
    },

    async getQueryRoles() {
      let { phone } = this.ruleForm;
      let { serverId } = this.ruleForm;
      
      if (!serverId || serverId <= 0) {
        this.$message({
          type: 'error',
          message: "请选择服务器！"
        })
        return;
      }
      
      if (!phone) {
        this.$message({
          type: 'error',
          message: "请先输入安全手机号码！"
        })
        return;
      }
      
      let params = { 
        currentPhone: Number(phone), 
        serverId: Number(serverId)
      };
      
      try {
        let ulrs = await recharApi.getQueryRoles(params);
        this.rolesList = ulrs.data;
        
        // 如果没有角色信息，给出提示
        if (!this.rolesList || this.rolesList.length === 0) {
          this.$message({
            type: 'warning',
            message: "未查询到该手机号对应的角色信息！"
          })
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: "查询角色信息失败，请重试！"
        })
      }
    },

    // 创建二维码
    createQR(codeUrl) {  
      let opts = {
        errorCorrectionLevel: "H", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 5, //二维码留白边距
        width: 300, //宽
        height: 300, //高
        color: {
          dark: "#000", //前景色
          light: "#fff" //背景色
        }
      };
      
      QRCode.toDataURL(codeUrl, opts, (err, url) => {
        // 生成完成，关闭加载状态
        this.isQrLoading = false;
        
        if (err || !url) {
          this.payErrorMsg = "支付二维码生成失败，请重试！";
          this.qrCodeImg = '';
          return;
        }
        
        this.payErrorMsg = '';
        this.qrCodeImg = url;
      });
    },


    // 切换支付方式
    handlePayTypeChange() {
      // 【修改3】清空原有二维码和错误信息
      this.qrCodeImg = '';
      this.payErrorMsg = '';
      
      // 根据选择的支付方式更新payId
      this.ruleForm.payId = this.selectedPayType === 'wechat' ? '700' : '200';
      
      // 【修改4】根据选择的支付方式调用对应的二维码获取方法
      if (this.selectedPayType === 'alipay') {
        this.getAlipayPayQrCode();
      } else if (this.selectedPayType === 'wechat') {
        this.getPayQrCode();
      }
    },

    // 获取微信支付二维码
    async getPayQrCode() {
      try {
        const params = Object.assign({}, this.ruleForm);
        params.p700.roleName = params.roleName;
        params.p700.phone = params.phone;
        params.p700.payWay = 'WEIXIN';
        params.p700.payType ='SCANPAY_WEIXIN';
        delete params.p200;
        let res = await recharApi.unifiedOrder(params);
        
        if (res.code == 200) {
          this.createQR(res.data.p700.qrCode);
        } else {
          this.payErrorMsg = res.message || "获取支付二维码失败，请重试！";
          if (res.code == 40002) {
            this.payErrorMsg = "用户信息有误！";
          }
        }
      } catch (error) {
        this.payErrorMsg = "网络异常，获取支付二维码失败！";
      }
    },



      // 获取支付宝支付二维码
      async getAlipayPayQrCode() {
        try {
          this.isQrLoading = true; // 开启加载状态
          // 组装请求参数
          const params = Object.assign({}, this.ruleForm);
          
          // 支付宝只使用 p200 字段，完全屏蔽 p700 相关字段
          params.p200 = {
            roleName: params.roleName,
            phone: params.phone
          };
          
          // 直接删除整个 p700 对象，确保它不会被传给后端
          delete params.p700;
          
          // 调用统一下单接口
          let res = await recharApi.unifiedOrder(params);
          
          // 支付宝返回的是 qrCode 字段
          if (res.code === 200 && res.data && res.data.p200 && res.data.p200.qrCode) {
            // 使用支付宝返回的 qrCode 生成二维码
            this.createQR(res.data.p200.qrCode);
            
            // 可选：显示订单金额信息
            if (res.data.p200.payAmount) {
              this.payAmount = res.data.p200.payAmount;
            }
          } else {
            this.isQrLoading = false; // 关闭加载状态
            this.payErrorMsg = res.message || "获取支付宝支付二维码失败，请重试！";
            if (res.code === 40002) {
              this.payErrorMsg = "用户信息有误！";
            }
            this.qrCodeImg = '';
          }
        } catch (error) {
          this.isQrLoading = false; // 关闭加载状态
          console.error('支付宝支付二维码获取失败:', error);
          this.payErrorMsg = "网络异常，获取支付宝支付二维码失败！";
          this.qrCodeImg = '';
        }
      },
          
    
    // 充值
    async topup() {
      // 检查是否同意协议
      if (!this.isSelected) {
        this.$message({
          type: 'error',
          message: "用户协议未同意"
        });
        return;
      }

      // 表单验证
      try {
        await this.$refs.ruleForm.validate();
        
        // 【修改5】显示支付选择弹框，但不默认生成任何二维码
        this.voucherPayShow = true;
        // 清空原有支付状态
        this.selectedPayType = '';
        this.ruleForm.payId = '';
        this.qrCodeImg = '';
        this.payErrorMsg = '';
        
      } catch (error) {
        // 表单验证失败
        return false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
// 原有样式保持不变，新增支付方式选择器样式
.pay-type-selector {
  ::v-deep .el-radio {
    font-size: 16px;
    color: #502d07;
  }
  
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background-color: #77420c;
    border-color: #77420c;
  }
  
  ::v-deep .el-radio__inner:hover {
    border-color: #77420c;
  }
}

// 其他原有样式...
.voucher-count{
  width: 100%;
  ::v-deep .el-dialog--center{
     border: 1px solid;
     border-radius: 2%;
    }
}

.self-demo-dialog {
  position: fixed;
  ::v-deep .el-form-item__label {
    position: relative;
  }
  ::v-deep .el-dialog {
    background-image: url('../../../assets/image/pc/recharge/bjpc.png');
    background-size: 100% 100%;
    background-color: transparent;
    border-radius: 3%;
    -webkit-box-shadow: 0 1px 3px transparent;
    box-shadow: 0 1px 3px transparent;
    }
    ::v-deep .el-dialog_body{
      padding: 15px auto !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    }
    ::v-deep .el-dialog__header {
      padding: 0px 10px 10px;
    }
  ::v-deep .el-form-item__label:before {
    display: inline-block;
    position: relative;
    top: 3px;
    left: -2px;
    content: '' !important;
    width: 14px;
    height: 16px;
    background: url(../../../assets/image/pc/recharge/lx.png) no-repeat !important;
    background-size: 14px 16px !important;
  }
  ::v-deep  .el-form {
      // min-width: 400px;
      }
  ::v-deep  .el-form-item__label {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        color: #502d07;
  }
  ::v-deep  .el-input--suffix {
        width: 300px;
  }
    ::v-deep  .el-input__inner {
        font-size: 16px;
      }  
    ::v-deep  .el-select-dropdown__list span {
      font-size: 16px;
    }
}

::v-deep .el-dialog__body {
  padding: 15px auto !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
::v-deep .el-dialog__headerbtn .el-dialog__close{
  font-size: 12px;
   line-height: 4px;
   color: #502d07;
}
.self-qr-desc {
  font-size: 16px;
}
.self-qr-footer {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 16px;
    display: block;
    border: 1px red solid;
  }
  p {
    font-size: 16px;
    margin-left: 15px;
  }
}
.voucher-title {
  font-size:12px;
  font-weight:600;
  color: #77420c;
  margin-bottom: 4%;
}
.message-content{
  height: 5%;
  flex: content;
  size: 30px;
  text-align: center;
  color: red;
  font-weight: bold;
}
.topup {
  width: 50px;
  height: 12px;
  text-align: center;
  line-height: 35px;
  margin: 4px auto;
  background-size: 100% 100%;
  color: #eac46c;
  cursor: pointer;
  background-image: url('../../../assets/image/pc/recharge/anpc.png');
}
.noimg {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  border-radius: 5px;
  img {
    width: 18px;
    height: 12 px;
  }
}
.msg {
  font-weight: 200;
  font-weight: bold;
  color:  #502d07;
  margin-bottom: 1%;
  a {
    text-decoration: underline;
    cursor: pointer;
  }
  button {
    padding: 2%;
    background-color: #fbf8f1;
    border:1px solid #fbf8f1;;
    width: 5px;
    height: 5px;
    border-radius: 15%; 
  }
}
.is-selected {
  width: 14px;
  height: 16px;
  background: url(../../../assets/image/pc/recharge/check.png) no-repeat !important;
  background-size: 5px 5px !important;
}
.voucherPay{
  width: 80%;
  height: 50%;
  margin: auto;
}
.self-qr-desc {
  font-size: 16px;
  text-align: center;
}
.self-qr-number{
  font-size: 16px;
  text-align: center;
  color: red;
}
.self-qr-footer {
  display: flex;
  align-items: center;
  width: 30%;
  height: 30%;
  margin: auto;
  img {
    width: 30px;
    height: 25px;
    display: block;
    border: 1px #ffff  solid;
  }
  p {
    font-size: 16px;
    margin-left: 5px;
  }
}
</style>